import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { TransitionGroup, Transition } from 'react-transition-group';
import { reDraw } from '../../../../../helpers/common';
import { propArrayShape } from '../../../../../helpers/custom-prop-types';
import Hover from '../../../../Ui/System/Hover';
import ArticleCard from './ArticleCard';
const ArticleCards = (props) => {
    const { articles } = props;
    return (_jsx(TransitionGroup, Object.assign({ component: null }, { children: articles.map((article) => (_jsx(Transition, Object.assign({ mountOnEnter: true, onEnter: reDraw, onExit: reDraw, timeout: 300, unmountOnExit: true }, { children: (state) => (_jsx(Hover, { children: _jsx("li", Object.assign({ className: `item zoom_image_parent transition ${state}` }, { children: _jsx(ArticleCard, { article: article }) })) })) }), article.id))) })));
};
ArticleCards.propTypes = {
    articles: propArrayShape().isRequired,
};
export default ArticleCards;
